import { render, staticRenderFns } from "./ActiveWatchlistSelector.vue?vue&type=template&id=fe864dd8&scoped=true&"
import script from "./ActiveWatchlistSelector.vue?vue&type=script&lang=js&"
export * from "./ActiveWatchlistSelector.vue?vue&type=script&lang=js&"
import style0 from "./ActiveWatchlistSelector.vue?vue&type=style&index=0&id=fe864dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe864dd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe864dd8')) {
      api.createRecord('fe864dd8', component.options)
    } else {
      api.reload('fe864dd8', component.options)
    }
    module.hot.accept("./ActiveWatchlistSelector.vue?vue&type=template&id=fe864dd8&scoped=true&", function () {
      api.rerender('fe864dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/main/ActiveWatchlistSelector.vue"
export default component.exports